/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-08-25 19:51:56
 * @LastEditors: chenhongwei chenhw2019@gmail.com
 * @LastEditTime: 2023-05-25 15:32:36
 */
const vuex_teamConfig = JSON.parse(localStorage.getItem('vuex_teamConfig') || '{"platform_list":[]}');
export default {
	vuex_teamConfig: vuex_teamConfig, // 团队配置
};
